function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "search-altt",
  d: "M12.568,0A12.568,12.568,0,1,0,25.135,12.568,12.568,12.568,0,0,0,12.568,0Zm.862,5.446a6.088,6.088,0,1,1-2.82,11.486s0,.008,0,.013L7.867,19.689l-2.25-2.251,2.648-2.65.014,0a6.089,6.089,0,0,1,5.15-9.338Zm0,2.7a3.383,3.383,0,1,0,3.383,3.384A3.385,3.385,0,0,0,13.43,8.151Z",
  fill: "#ac1ede"
});

var SvgSearchAltt = function SvgSearchAltt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25.135,
    height: 25.135,
    viewBox: "0 0 25.135 25.135",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchAltt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-altt.a3d454cd.svg";
export { ForwardRef as ReactComponent };